const URL = {
  GET_BADGES: 'badge/list',
}

export default URL
